// extracted by mini-css-extract-plugin
export default {"anchor":"xVeDkX"};